<template>
  <v-dialog persistent v-model="showdeletechannel" width="500">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        <span>
          Delete Channel
          <span class="font-weight-medium">
            &nbsp;"{{ channel.conversation_name }}"
          </span>
        </span>
      </v-card-title>

      <v-card-text>
        Are you sure you want to delete this channel and all of its messages?
        <span class="font-weight-black">This can't be undone.</span>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="secondary" text @click.stop="closedialog()">
          Cancel
        </v-btn>
        <v-btn color="primary" text @click.prevent="submit()">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteChannel",
  props: {
    showdeletechannel: Boolean,
    acls: Array,
    currentlySelectedAccount: String,
    channel: Object,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    closedialog() {
      this.$emit("closedialog");
    },
    async submit() {
      const data = {
        accountname: this.currentlySelectedAccount,
        channelname: this.channel.conversation_name,
      };
      const res = await this.$store.dispatch("deleteChannel", data);
      if (res.Error) {
        this.$store.dispatch("addNotification", {
          type: "errorMessage",
          message: `${res.Error}`,
        });
      } else {
        this.$store.dispatch("addNotification", {
          type: "success",
          message: `Channel "${this.channel.conversation_name}" has been deleted successfully`,
        });
      }
      this.$emit("refreshconversations");
      this.$emit("closedialog");
    },
  },
};
</script>

<style></style>
